<template>
  <div id="useHelp">
    <!--导航-->
    <div class="nav-content">
      <div class="main">
        <div class="logo-contain">
          <img src="@/assets/images/logo.png" class="logo-set">
          <div class="logo-text">
            <p>快点打印</p>
            <small>黑白之间，<span style="color: #f8726b">色彩</span>纷呈~~</small>
          </div>
        </div>
        <div class="nav-list">
          <ul>
            <li>
              <router-link to="/Home" :class="{'a-active':isactive == 0}">首页</router-link>
            </li>
<!--            <li>-->
<!--              <router-link to="/UseHelp" :class="{'a-active':isactive == 1}">使用帮助</router-link>-->
<!--            </li>-->
            <li>
              <router-link to="/News"  :class="{'a-active':isactive == 2}">新闻动态</router-link>
            </li>
            <!--<li>
              <router-link to="/Down" :class="{'a-active':isactive == 3}">客户端下载</router-link>
            </li>-->
            <li>
              <router-link to="/About"  :class="{'a-active':isactive == 4}">关于快点</router-link>
            </li>
            <li>
              <router-link to="/JoinUs"  :class="{'a-active':isactive == 5}">加入我们</router-link>
            </li>
            <li>
              <router-link to="/Regester"  :class="{'a-active':isactive == 6}">账号注册</router-link>
            </li>
          </ul>
        </div>
        <div class="clear-float"></div>
      </div>
    </div>
    <!--用户注册-->
    <div class="use-contain">
      <div class="main">
        <el-row class="tac">
          <el-col :span="12" :offset="6" class="menu-content">
            <el-form v-loading="isloading" ref="form" :model="form" :rules="rules" label-width="100px">
                  <h3 style="margin-top: 4rem">请在各大手机应用商店安装快点云打印APP获取账号</h3>
<!--              <el-row type="flex" justify="center">-->
<!--                <el-col :span="24">-->
<!--                  <el-form-item label-width="70px">-->
<!--                    <h3>快速注册</h3>-->
<!--                  </el-form-item>-->
<!--                </el-col>-->
<!--              </el-row>-->
<!--              <el-row type="flex" justify="center">-->
<!--                <el-col :span="18">-->
<!--                  <el-form-item maxlength="11" label="手机号：" prop="phone">-->
<!--                    <el-input v-model="form.phone" size="small"></el-input>-->
<!--                  </el-form-item>-->
<!--                </el-col>-->
<!--              </el-row>-->
<!--              <el-row type="flex" justify="center" class="rowDiv">-->
<!--                  <el-form-item label="验证码：" prop="code">-->
<!--                    <el-input class="input-radius" style="width: 200px;margin-left: -35px;" maxlength="6" v-model="form.code" size="small"></el-input>-->
<!--                  </el-form-item>-->
<!--                  <el-button style="margin-top: 5px;margin-left: -80px;width:120px; border-radius: 0px 4px 4px 0px;"  type="primary" size="small" @click="getcode" :disabled="btnloading" v-if="btnloading==false">-->
<!--                    <span>{{btntext}}</span>-->
<!--                  </el-button>-->
<!--                  <el-button style="margin-top: 5px;margin-left: -80px;width:120px; border-radius: 0px 4px 4px 0px;"  type="primary" size="small" @click="getcode" :disabled="btnloading" v-if="btnloading==true">-->
<!--                    <span>{{btntext}}</span>-->
<!--                  </el-button>-->
<!--              </el-row>-->
<!--              <el-row type="flex" justify="center">-->
<!--                <el-col :span="18">-->
<!--                  <el-form-item label="密码：" prop="password">-->
<!--                    <el-input type="password" maxlength="16" v-model="form.password" size="small"></el-input>-->
<!--                  </el-form-item>-->
<!--                </el-col>-->
<!--              </el-row>-->
<!--              <el-row type="flex" justify="center">-->
<!--                <el-col :span="18">-->
<!--                  <el-form-item label="再次输入：" prop="repeat">-->
<!--                    <el-input type="password" maxlength="16" v-model="form.repeat" size="small"></el-input>-->
<!--                  </el-form-item>-->
<!--                </el-col>-->
<!--              </el-row>-->
<!--              <el-row type="flex" justify="center">-->
<!--                <el-col :span="12">-->
<!--                  <el-form-item>-->
<!--                    <el-button style="width: 120px" type="primary" @click="regester()">注册</el-button>-->
<!--                  </el-form-item>-->
<!--                </el-col>-->
<!--              </el-row>-->
            </el-form>
          </el-col>
        </el-row>
      </div>
    </div>
    <!--底部-->
    <bottom ref="bottom"></bottom>
  </div>
</template>

<script>
import bottom from './common/Bottom'
import * as Api from '../assets/js/Api'
import axios from 'axios'

export default {
  data () {
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    let checkPhone = (rule, value, callback) => {
      const reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/
      if (this.form.phone === '') {
        callback(new Error('手机号不能为空'))
      }
      if (!reg.test(this.form.phone)) {
        callback(new Error('请输入正确的手机号'))
      }
    }
    return {
      isloading: false,
      btnloading: false,
      isactive: '',
      btntext: '获取验证码',
      time: 0,
      form: {
        phone: '',
        password: '',
        code: '',
        repeat: ''
      },
      rules: {
        phone: [
          { validator: checkPhone, trigger: 'change' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入8到16位密码', trigger: 'blur' },
          { min: 8, max: 16, message: '密码8到16位', trigger: 'blur' }
        ],
        repeat: [
          { validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    Api.changeClass = 6
    this.isactive = Api.changeClass
  },
  components: {
    bottom: bottom
  },
  methods: {
    // 120S倒计时
    timer () {
      if (this.time > 0) {
        this.time--
        this.btntext = '重新获取(' + this.time + ')s'
        setTimeout(this.timer, 1000)
      } else {
        this.time = 0
        this.btntext = '获取验证码'
        this.btnloading = false
      }
    },
    getcode: function () {
      const reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/
      if (this.form.phone === '' || !reg.test(this.form.phone)) {
        window.bus.$message({
          message: '请检查手机号码是否正确',
          type: 'warning'
        })
        return
      }
      this.isloading = true
      axios.get(Api.getCode + this.form.phone, {
        headers: {'x-sms-type': 'userRegister'}
      }).then((response) => {
        this.isloading = false
        if (response.status === 200) {
          let msg = response.data.msg
          if (response.data.msg === 'success') {
            msg = '验证码发送成功'
          }
          window.bus.$message({
            message: msg,
            type: 'info'
          })
          this.time = 120
          this.btnloading = true
          this.timer()
        } else {
          window.bus.$message({
            message: '验证码发送失败，请重试',
            type: 'warning'
          })
        }
      }, (response) => {
        this.isloading = false
        window.bus.$message({
          message: '请求超时，请检查网络',
          type: 'warning'
        })
      })
    },
    regester: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false
        }
      })
      let formData = new FormData()
      formData.append('mobile', this.form.phone)
      formData.append('code', this.form.code)
      formData.append('password', this.form.password)
      this.isloading = true
      axios({url: Api.register,
        method: 'post',
        data: formData
      }).then((response) => {
        this.isloading = false
        console.log(response)
        if (response.status === 200) {
          // let message = response.data.msg
          if (response.data.msg === 'success') {
            window.bus.$message({
              message: '注册成功。',
              type: 'success'
            })// 重置输入框
            this.$refs.form.resetFields()
          } else {
            window.bus.$message({
              message: response.data.msg,
              type: 'warning'
            })
          }
          // this.newsList = response.data
        } else {
          window.bus.$message({
            message: '注册失败，请重试',
            type: 'warning'
          })
        }
      }, (response) => {
        console.log(response)
        this.isloading = false
        window.bus.$message({
          message: '请求超时，请检查网络',
          type: 'warning'
        })
      })
    }
  }
}
</script>

<style>
  .rowDiv{
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .rowDiv .el-button{
    margin-top: 0 !important;
    margin-left: 10px !important;
    width: 100px !important;
    margin-bottom: 22px !important;
  }
  .rowDiv .el-form-item__content{
    margin-left: 140px !important;
  }
  .rowDiv .el-form-item__error{
    margin-left: -36px !important;
  }
  .rowDiv .el-form-item{
    padding: 0;
    margin: 0;
    margin-bottom: 22px !important;
  }
 .el-message {
  text-align: center!important;
  display: block !important;
}
 .el-message p{
   display: inline-block;
 }
  .watchvideo{
    cursor: pointer;
    color: blue;
    text-decoration: underline;
  }
  .watchvideo span{
  }
  .nav-content {
    width: 100%;
    height: 80px;
  }

  .logo-contain {
    float: left;
    padding-top: 15px;
  }

  .logo-set {
    width: auto;
    height: 50px;
    vertical-align: center;
    margin-right: 10px;
  }

  .logo-text {
    display: inline-block;
    text-align: left;
    vertical-align: top;
  }

  .logo-text p {
    font-size: 20px;
    color: #333;
  }

  .logo-text small {
    font-size: 14px;
    color: #999;
  }

  .nav-list {
    float: right;
  }

  .nav-list li {
    display: inline-block;
    height: 50px;
    width: 150px;
  }

  .nav-list li a {
    border-bottom: 2px solid #fff;
    width: 100px;
    color: #333;
    font-size: 16px;
    line-height: 78px;
  }

  .nav-list li a:hover {
    color: #f62828;
    border-bottom: 2px solid #f62828;
  }

  .nav-list li .a-active {
    color: #f62828;
    border-bottom: 2px solid #f62828;
  }
  .main {
    width: 1200px;
  }
  .use-contain{
    width: 100%;
    background-color: #f5f5f5;
    padding: 90px 0px 140px 0px;
  }
  .menu-bar{
    border-radius: 3px;
    background-color: #fff;
    box-shadow: 3px 5px 10px -2px rgba(0,0,0,0.09),
    -3px -5px 10px -2px rgba(0,0,0,0.09);
    padding: 20px 0px;
  }
  .menu-bar li{
    padding: 0px 40px;
    text-align: left;
    height: 50px;
    line-height: 50px;
    cursor: pointer;
  }
  .menu-bar li:hover{
    background-color: #f62828;
    color: #fff;
  }
  .menu-bar .li-active{
    background-color: #f62828;
    color: #fff;
  }
  .menu-bar li p{
    font-size: 18px;
    display: inline-block;
  }
  .menu-bar li i{
    float: right;
    line-height: 50px;
  }
  .menu-bar li span{
    padding-left: 15px;
    font-size: 14px;
  }
  .menu-content{
    border-radius: 3px;
    background-color: #fff;
    box-shadow: 3px 5px 10px -2px rgba(0,0,0,0.09),
    -3px -5px 10px -2px rgba(0,0,0,0.09);
    min-height: 280px;
    padding: 30px;
  }
  .menu-text{
    text-align: left;
  }
  .menu-text h3{
    font-size: 16px;
    color: #333;
    line-height: 40px;
  }
  .menu-text p{
    font-size: 14px;
    color: #444;
    line-height: 30px;
  }
  .common-bottom {
    width: 100%;
    background-color: #434343;
    color: rgba(255, 255, 255, 0.8);
    text-align: left;
    padding: 30px 0px;
  }
  .block-none{
    display: none;
  }
  .bottom-ul h5 {
    font-size: 18px;
    font-weight: normal;
    width: 50%;
    border-bottom: 1px solid #fff;
    padding-bottom: 10px;
    margin-bottom: 10px;
    margin-left: 0px;
  }

  .bottom-ul a, .bottom-ul span {
    font-size: 14px;
    line-height: 25px;
  }

  .bottom-ul span {
    margin-left: 5px;
  }
  .bottom-ul a {
    color: rgba(255, 255, 255, 0.8);
  }
  .bottom-ul a:hover {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: underline;
  }

  .code-set {
    width: 120px;
    height: 120px;
  }
  .input-radius input{
    border-radius: 4px 0px 0px 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Regester.vue